module.exports = __webpack_public_path__ + "img/v_4.1da6e957.svg";